import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import BaseListPage from "../../../../base/BaseListPage";
import CardView from "../../../../components/common/CardView";
import { FloatingForm } from "../../../../components/common/Converter";
import PayrollTablePresenter from "./PayrollTablePresenter";
import LogoHeader from "../../../../components/common/LogoHeader";
import { PrintPayrollListPage } from "./actions/PrintPayrollListPage";
import { ExportPage } from "./actions/ExportPage";
import { formattedRate } from "../../../../components/common/Converter";
import Progress from "../../../../components/Progress";
import { _chunkArray } from "../../../Finance/Payroll/helper-payroll/HelperFunction";

export default class PayrollTable extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new PayrollTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      totalAmount: 0,
      limit: 100,
      current: 1,
      count: 0,
      employees: [],
    };
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    try {
      const { ids } = this.props;

      const idChunks = _chunkArray(ids, 100);
      const requests = [];

      for (const chunk of idChunks) {
        if (!chunk || chunk.length === 0) continue;
        requests.push(
          findObjectUseCase().execute("employees", {
            where: {
              id: { $in: chunk },
            },
          }).catch(err => {
            console.error("Error fetching employee chunk:", err);
            return [];
          })
        );
      }

      const results = await Promise.all(requests);
      const allEmployees = [];
      for (let i = 0; i < results.length; i++) {
        const result = results[i];
        for (let j = 0; j < result.length; j++) {
          allEmployees.push(result[j]);
        }
      }
      this.setState({ employees: allEmployees });
    } catch (error) {
      console.error("Error in componentDidMount:", error);
      this.setState({ employees: [] });
    }
  }

  getCollectionName() {
    return this.props.isBackpay ? "payroll_back_pay" : "payroll";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleExport = () => {
    const { employees } = this.state;
    const { payrollData } = this.props;

    // const obj = [
    //   {
    //     Firstname: "ORLANDO JR",
    //     surname: "ABENGOZA",
    //     accountNumber: "0017278304",
    //     id: "1",
    //   },
    // ];

    // const payData = [
    //   {
    //     netAmount: 25311.56,
    //     employee: {
    //       id: "1",
    //     },
    //   },
    // ];

    ExportPage(employees, payrollData);
  };

  handlePrint = () => {
    const { objects } = this.state;
    const { payrollData } = this.props;
    PrintPayrollListPage(objects, payrollData);
  };

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, limit, current } = this.state;
    console.log("objects", objects);
    const { payrollData, isBackpay } = this.props;
    console.log("payrollData", payrollData);

    if (!schema) return <Progress />;

    // const parseAndFormat = (value) =>
    //   parseFloat(formattedRate(value.toString()));
    // const totalAmount = parseAndFormat(
    //   objects.reduce((acc, obj) => acc + (obj.netAmount || 0), 0)
    // );

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "employee" &&
      fields !== "netAmount" 
    );

    return (
      <>
        <FloatingForm width="75rem">
          <CardView style={{ padding: 0 }}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                // this.handleSubmit();
              }}
            >
              <div className="d-flex justify-content-center flex-column align-items-center flex-md-row  p-2">
                <LogoHeader
                  logoSrc={"/BIR.png"}
                  rightLogoSrc={"/Bagong-Pilipinas-Logo.png"}
                  altText="Print Logo"
                  mainLabel="Republic Of the Philippines"
                  subLabel="BUREAU OF IMMIGRATION"
                  description="Patriotism * Integrity * Professionalism"
                />
                {/* <img
                  src={"/Bagong-Pilipinas-Logo.png"}
                  alt="Logo Header 2"
                  style={{
                    maxWidth: "130px",
                    maxHeight: "110px",
                  }}
                /> */}
              </div>
              <br></br>

              <div
                className="fs-6 text-center"
                style={{ fontFamily: "monospace" }}
              >
                <p style={{ color: "green" }}>PAYROLL REGISTER</p>
              </div>

              <div className="overflow-auto">
                <InfiniteScroll
                  className="h-100"
                  loadMore={this.loadMore.bind(this)}
                >
                  <div className="p-3 p-lg-4">
                    <div
                      style={{
                        marginTop: "10px",
                        width: "100%",
                      }}
                    ></div>

                    <Table
                      progress={loading}
                      fields={schema.fields}
                      objects={objects}
                      collection={schema}
                      count={count}
                      limit={limit}
                      current={current}
                      loadPagination={this.onClickPagination.bind(this)}
                      excludeFields={Object.keys(schema.fields).reduce(
                        (acc, key) => {
                          const options = schema.fields[key];
                          if (options.read === false) {
                            acc.push(key);
                          }
                          switch (options._type || options.type) {
                            case "Relation":
                            // case "Array":
                            case "Object":
                            case "File":
                              acc.push(key);
                              break;
                            default:
                          }
                          return acc;
                        },
                        ["Id", "Created At", "Updated At", ...includeLabel]
                      )}
                      onClickItem={this.onClickItem.bind(this)}
                      fieldPointer={[
                        {
                          item: "accountNumber",
                          label: "ACCOUNT NUMBER",
                          _type: "Pointer",
                          sourceField: "employee",
                        },
                      ]}
                    />
                  </div>
                </InfiniteScroll>
              </div>
              <br></br>
              <div
                className="fs-6 text-center"
                style={{ fontFamily: "monospace" }}
              >
                <p>
                  TOTAL NUMBER OF RECORDS <b>{payrollData.length}</b>
                </p>
              </div>

              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}></div>

              <div className="w-100 d-flex justify-content-end gap-2 mb-3 pe-3">
                <button
                  className="btn btn-light"
                  onClick={() => this.props.closePayrollForm()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.handleExport}
                >
                  Export
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.handlePrint()}
                >
                  Print
                </button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
